export class SearchResources200ResponseTablesInnerSnapshots {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "latestSnapshotId",
            "baseName": "latestSnapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "latestSnapshotISODate",
            "baseName": "latestSnapshotISODate",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSnapshots",
            "baseName": "totalSnapshots",
            "type": "number",
            "format": ""
        },
        {
            "name": "latestSnapshotVaultId",
            "baseName": "latestSnapshotVaultId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResources200ResponseTablesInnerSnapshots.attributeTypeMap;
    }
    constructor() {
    }
}
